import { render, staticRenderFns } from "./Wechat.vue?vue&type=template&id=72e360a8&"
import script from "./Wechat.vue?vue&type=script&lang=js&"
export * from "./Wechat.vue?vue&type=script&lang=js&"
import style0 from "./Wechat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports